import React from 'react';
import { Box } from 'src/design/atoms/Box';
import { Divider } from 'src/design/atoms/Divider';
import { Group } from 'src/design/atoms/Group';
import { Stack } from 'src/design/atoms/Stack';
import { BasicActionIcon } from 'src/design/atoms/BasicActionIcon';
import { IconMenu2, IconMenuDeep } from '@tabler/icons-react';
import { Logo } from 'src/app/navigation/Logo';
import { HeaderContent } from 'src/app/navigation/HeaderContent';
import { JobSelectorMobileBar } from 'src/app/selectors/JobSelectorMobileBar';
import { useAuth } from 'src/hooks/useAuth';
import { useMenu } from 'src/hooks/useMenu';
import { JOB_BAR_HEIGHT, NAV_ROW_HEIGHT } from 'src/config';

export interface INavigationHeaderProps {
  open: boolean;
  handleDrawerToggle: () => void;
}

/** @registry Top app header: logo, drawer toggle, and HeaderContent; on mobile also renders the job selector bar below the nav row. */
export const NavigationHeader: React.FC<INavigationHeaderProps> = ({
  open,
  handleDrawerToggle,
}) => {
  const { isMobile } = useMenu();
  const { checkFeatureAllowed } = useAuth();
  const hasJobs = checkFeatureAllowed(['jobs']);

  const navRow = (
    <Group h={NAV_ROW_HEIGHT} px="sm" wrap="nowrap">
      <Logo />
      <BasicActionIcon
        variant={open ? 'light' : 'subtle'}
        color="dark"
        size="lg"
        aria-label="open drawer"
        onClick={handleDrawerToggle}
      >
        {open ? <IconMenuDeep /> : <IconMenu2 />}
      </BasicActionIcon>
      <HeaderContent />
    </Group>
  );

  if (!isMobile) return navRow;

  return (
    <Stack gap={0} h="100%" bg="var(--mantine-color-body)">
      {navRow}
      {hasJobs && (
        <>
          <Divider />
          <Box h={JOB_BAR_HEIGHT} bg="var(--mantine-color-body)">
            <JobSelectorMobileBar />
          </Box>
        </>
      )}
    </Stack>
  );
};
